import React, { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState(() => {
    const saved = localStorage.getItem('sbb_cart');
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    localStorage.setItem('sbb_cart', JSON.stringify(cartItems));
  }, [cartItems]);

  const addToCart = (product, volume = 5, truckType = 'standard', extras = {}) => {
    setCartItems(prev => {
      // For concrete, usually we don't merge but add as new line if different specs
      const newItem = {
        cartId: Date.now(),
        productId: product.id,
        sku: product.sku,
        name: product.name,
        category: product.category,
        image_url: product.image_url,
        volume: parseFloat(volume),
        truckType: truckType,
        pricePerM3: parseFloat(product.price_per_m3 || 0),
        pumpRequired: false,
        projectLocation: '',
        pouringDate: '',
        ...extras
      };
      return [...prev, newItem];
    });
  };

  const removeFromCart = (cartId) => {
    setCartItems(prev => prev.filter(item => item.cartId !== cartId));
  };

  const updateItem = (cartId, updates) => {
    setCartItems(prev => prev.map(item => 
      item.cartId === cartId ? { ...item, ...updates } : item
    ));
  };

  const clearCart = () => {
    setCartItems([]);
  };

  const cartTotal = cartItems.reduce((acc, item) => acc + (item.volume * item.pricePerM3), 0);

  return (
    <CartContext.Provider value={{ 
      cartItems, 
      addToCart, 
      removeFromCart, 
      updateItem, 
      clearCart,
      cartTotal 
    }}>
      {children}
    </CartContext.Provider>
  );
};
